// Direct Pagination Fix - No AJAX for TML Collection
document.addEventListener('DOMContentLoaded', function() {
  // Stop the theme's AJAX behavior
  function disableAjaxBehavior() {
    // Remove ajax filter class to prevent theme AJAX
    const filterContainer = document.querySelector('[data-ajax-filter]');
    if (filterContainer) {
      filterContainer.setAttribute('data-ajax-filter', 'false');
    }
    
    // Remove other AJAX indicators
    const ajaxContainers = document.querySelectorAll('[data-ajax-container], [data-ajax-scroll-to]');
    ajaxContainers.forEach(container => {
      container.removeAttribute('data-ajax-container');
      container.removeAttribute('data-ajax-scroll-to');
    });
    
    // Disable infinite scroll
    const infiniteScrollElements = document.querySelectorAll('.infiniscroll, .pagination.infiniscroll');
    infiniteScrollElements.forEach(element => {
      element.classList.remove('infiniscroll');
    });
    
    if (window.theme && window.theme.unloadInfiniteScroll) {
      window.theme.unloadInfiniteScroll(document);
    }
  }
  
  // // Remove loading indicators
  // function removeLoadingIndicators() {
  //   // Stop all XHR requests
  //   if (window.theme && window.theme.FilterManager) {
  //     const fm = window.theme.FilterManager;
  //     if (fm.currentAjaxLoadUrlFetch) {
  //       try {
  //         fm.currentAjaxLoadUrlFetch.abort();
  //       } catch (e) {}
  //     }
  //   }
    
  //   // Remove loading spinners
  //   const loadingSpinners = document.querySelectorAll('.loading, [class*="loading"], .product-list .loading');
  //   loadingSpinners.forEach(spinner => {
  //     if (spinner && spinner.parentNode) {
  //       spinner.parentNode.removeChild(spinner);
  //     }
  //   });
    
  //   // Remove loading classes
  //   const loadingContainers = document.querySelectorAll('.cc-product-filter-container--loading');
  //   loadingContainers.forEach(container => {
  //     container.classList.remove('cc-product-filter-container--loading');
  //   });
  // }
  
  // Get page number from URL
  function getPageFromUrl() {
    const url = new URL(window.location.href);
    return url.searchParams.get('page') || '1';
  }
  
  // Set page number in URL
  function updateUrlPageParam(pageNum) {
    const url = new URL(window.location.href);
    if (pageNum === 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', pageNum);
    }
    return url.toString();
  }
  
  // Handle pagination click with page reload
  function setupPaginationLinks() {
    const paginationLinks = document.querySelectorAll('#tml-pagination a, .pagination a');
    
    paginationLinks.forEach(link => {
      // Skip if already enhanced
      if (link.hasAttribute('data-page-enhanced')) return;
      link.setAttribute('data-page-enhanced', 'true');
      
      // Extract the page number from the link
      let pageNumber = null;
      
      try {
        // Try to extract page number from href
        const linkUrl = new URL(link.href);
        pageNumber = linkUrl.searchParams.get('page');
        
        // If link text is a number, use that as fallback
        if (!pageNumber && /^\d+$/.test(link.textContent.trim())) {
          pageNumber = link.textContent.trim();
        }
        
        // Handle next/previous links
        if (!pageNumber) {
          const currentPage = parseInt(getPageFromUrl() || 1);
          if (link.textContent.includes('Next') || link.innerHTML.includes('&raquo;')) {
            pageNumber = currentPage + 1;
          } else if (link.textContent.includes('Previous') || link.innerHTML.includes('&laquo;')) {
            pageNumber = Math.max(1, currentPage - 1);
          }
        }
      } catch (e) {
        console.error('Error parsing pagination link:', e);
      }
      
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Store scroll position in sessionStorage
        sessionStorage.setItem('tml_collection_scroll_position', window.scrollY);
        sessionStorage.setItem('tml_collection_goto_page', pageNumber || 1);
        
        // Redirect to the correct page
        const url = updateUrlPageParam(pageNumber || 1);
        window.location.href = url;
      });
    });
  }
  
  // Restore scroll position after page load
  function handleScrollPosition() {
    const targetScrollY = sessionStorage.getItem('tml_collection_scroll_position');
    const targetPage = sessionStorage.getItem('tml_collection_goto_page');
    const currentPage = getPageFromUrl();
    
    if (targetScrollY && targetPage === currentPage) {
      // Clear stored values
      sessionStorage.removeItem('tml_collection_scroll_position');
      sessionStorage.removeItem('tml_collection_goto_page');
      
      // Scroll to a nice position
      const gridContainer = document.querySelector('.tml-card-collection__grid');
      if (gridContainer) {
        const containerTop = gridContainer.getBoundingClientRect().top + window.pageYOffset;
        const scrollToPosition = containerTop - 200;
        
        window.scrollTo({
          top: Math.max(0, scrollToPosition),
          behavior: 'smooth'
        });
      }
    }
  }
  
  // Watch for any DOM changes and reapply fixes
  const observer = new MutationObserver(function(mutations) {
    let hasRelevantChanges = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Check if pagination was added
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.matches) {
            if (
              node.matches('.pagination') || 
              node.matches('#tml-pagination') || 
              node.querySelector && node.querySelector('.pagination, #tml-pagination')
            ) {
              hasRelevantChanges = true;
            }
          }
        });
      }
    });
    
    // If pagination elements were added, set up the links again
    if (hasRelevantChanges) {
      setupPaginationLinks();
    }
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });

  // Run these functions on page load
  disableAjaxBehavior();
  setupPaginationLinks();
  handleScrollPosition();
});